import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--number-of-employees-edit-modal',
    ];

    openEditModal(event) {
        event.preventDefault();
        this.profileNumberOfEmployeesEditModalOutlet.openModal();
    }
}
